import get from 'transmute/get';
export const getIndexId = account => `${get('id', account)}`;